import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    createFilterOptions,
    Divider,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { DesktopDatePicker } from "@mui/lab";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useSelector } from "react-redux";
import { defaultInfo } from "../../../ConfigInfo/Info";

const RolesModal = ({ mode, handleCloseClick, editData }) => {
    const login = useSelector((state) => state.auth.loginInfo);
    const eamAdmin = login?.roleName === defaultInfo.roleName.eamSuperAdmin;
    const [loading, setLoading] = useState(false);
    const [licence, setLicence] = useState([]);
    const [autoLicence, setAutoLicence] = useState("");

    const OPTIONS_LIMIT = 10;
    const defaultFilterOptions = createFilterOptions();

    const filterOptions = (options, state) => {
        return defaultFilterOptions(options, state);
    };
    const CustomPaper = (props) => {
        return <Paper elevation={8} {...props} />;
    };

    useEffect(() => {
        getData();
    }, []);
    const getData = () => {
        const getAllLicence = masterAPI["licence"].getall;
        axiosPrivate
            .get(`${getAllLicence}`)
            .then((res) => {
                setLicence(res.data.result);
            })
            .catch((e) => {
                setLicence([]);
                console.log(e);
            });
    };
    const initialValue = {
        // code: mode === "Edit" ? editData.code : "",
        name: mode === "Edit" ? editData.name : "",
        licenceId: mode === "Edit" ? editData.licenceId : null,
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Role Name is required"),
        licenceId: !eamAdmin
            ? Yup.string().required("Licence is required").nullable()
            : Yup.string().nullable(),
    });

    const onSubmit = async (value) => {
        console.log(value);
        setLoading(true);
        const createLink = masterAPI["roles"].create;
        const updateLink = masterAPI["roles"].update;
        if (mode === "Create") {
            await axiosPrivate
                .post(`${createLink}`, value)
                .then((res) => {
                    console.log(res.data);
                    setLoading(false);
                    handleCloseClick();
                })
                .catch((e) => {
                    setLoading(false);
                    console.log(e, "create roles");
                });
        } else {
            const updateAC = {
                id: editData.id,
                ...value,
            };
            await axiosPrivate
                .put(`${updateLink}`, updateAC)
                .then((res) => {
                    console.log(res.data);
                    setLoading(false);
                    handleCloseClick();
                })
                .catch((e) => {
                    setLoading(false);
                    console.log(e, "update roles");
                });
        }
    };

    const handleCancel = () => {
        handleCloseClick();
    };

    return (
        <Box sx={{ p: color.masterPageDialogPadding }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <Typography
                    sx={{
                        color: color.masterDialogTitleColor,
                        fontSize: color.masterDialogFontSize,
                    }}
                >
                    {mode === "Edit" ? editData.name : "New Roles"}
                </Typography>
                <IconButton onClick={handleCancel}>
                    <Clear />
                </IconButton>
            </Box>
            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
            <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
                {({ handleChange, setFieldValue, values, resetForm, errors, touched }) => (
                    <Form>
                        <Grid container spacing={"1rem"}>
                            {/* <Grid item xs={12} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Role Code
                </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="code"
                    placeholder="Enter Code"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",

                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid> */}
                            <Grid item xs={12}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Role Name
                                </Typography>
                                <Field
                                    as={TextField}
                                    size={"small"}
                                    type="text"
                                    name="name"
                                    placeholder="Enter Name"
                                    fullWidth
                                    error={touched.name && Boolean(errors.name)}
                                    helperText={touched.name && errors.name}
                                    sx={{
                                        ".MuiInputBase-input": {
                                            // letterSpacing: "0.2rem",

                                            "&::placeholder": {
                                                // color: "green",
                                                opacity: 1,
                                                color: color.placeholderColor,
                                                fontSize: "13px",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{display:eamAdmin?"none":"default"}}>
                                <Typography
                                    sx={{
                                        fontWeight: color.labelFontWeight,
                                        mb: color.labelmb,
                                        fontSize: color.labelFont,
                                        color: color.labelColor,
                                    }}
                                >
                                    Licence
                                </Typography>
                                <Autocomplete
                                    fullWidth
                                    filterOptions={filterOptions}
                                    loading={licence.length === 0}
                                    // inputValue={autoLicence}
                                     value={
                                          licence.find(
                                            (p) =>p.id === values.licenceId) || null
                                        }
                                    options={licence}
                                    PaperComponent={CustomPaper}
                                    getOptionLabel={(option) =>
                                        option.userTypeName + " (" + option.licenceCount + ")" || ""
                                    }
                                    onChange={(event, value) => {
                                        if (value) {
                                            setFieldValue("licenceId",value.id)
                                            setAutoLicence(value.userTypeName+"("+value.licenceCount+")")
                                        } else {
                                            setFieldValue("licenceId",null)
                                            setAutoLicence("")
                                        }
                                    }}
                                    //  onInputChange={(event, newInputValue) => {
                                    //     setSel({ ...sel, autoOrg: newInputValue });
                                    //   }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            name="licenceId"
                                            placeholder="Select Licence"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error={touched.licenceId && Boolean(errors.licenceId)}
                                            helperText={touched.licenceId && errors.licenceId}
                                            onChange={(event) => {
                                                setAutoLicence(event.target.value)
                                            }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {licence.length === 0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                justifyContent={"flex-end"}
                                gap="1rem"
                            >
                                <Button
                                    onClick={handleCancel}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: color.TableCancelButton,
                                        textTransform: "none",
                                        color: color.CancelTextColor,
                                        ":hover": {
                                            backgroundColor: color.TableCancelButton,
                                            textTransform: "none",
                                            color: color.CancelTextColor,
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type={"submit"}
                                    variant="contained"
                                    disabled={loading}
                                    sx={{
                                        textTransform: "none",
                                        backgroundColor: loading
                                            ? "default"
                                            : color.TableButtonColor,
                                        "&:hover": {
                                            backgroundColor: loading
                                                ? "default"
                                                : color.buttonDisable,
                                        },
                                    }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default RolesModal;
